import { render } from "./DefaultButton.vue?vue&type=template&id=078e554c&scoped=true"
import script from "./DefaultButton.vue?vue&type=script&lang=js"
export * from "./DefaultButton.vue?vue&type=script&lang=js"

import "./DefaultButton.vue?vue&type=style&index=0&id=078e554c&lang=scss&scoped=true"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078e554c"]])

export default __exports__